import { render, staticRenderFns } from "./SettlementsView.vue?vue&type=template&id=5c8abc8c&scoped=true&"
import script from "./SettlementsView.vue?vue&type=script&lang=js&"
export * from "./SettlementsView.vue?vue&type=script&lang=js&"
import style0 from "./SettlementsView.vue?vue&type=style&index=0&id=5c8abc8c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8abc8c",
  null
  
)

export default component.exports